import { Editor } from 'slate';
import { getListItems, pickSubtreesRoots } from "../lib/index.js";
import { decreaseListItemDepth } from "./decreaseListItemDepth.js";
/**
 * Decreases nesting depth of all "list-items" in the current selection.
 * All "list-items" in the root "list" will become "default" nodes.
 *
 * @returns {boolean} True, if the editor state has been changed.
 */
export function decreaseDepth(editor, schema) {
  let at = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : editor.selection;
  if (!at) {
    return false;
  }
  const listItems = getListItems(editor, schema, at);

  // When calling `decreaseListItemDepth` the paths and references to "list-items"
  // can change, so we need a way of marking the "list-items" scheduled for transformation.
  const refs = pickSubtreesRoots(listItems).map(_ref => {
    let [_, path] = _ref;
    return Editor.pathRef(editor, path);
  });
  let handled = false;
  refs.forEach(ref => {
    if (ref.current) {
      handled = decreaseListItemDepth(editor, schema, ref.current) || handled;
    }
    ref.unref();
  });
  return handled;
}